import { LOG_LEVELS } from './types.js';
export class ConsoleLogger {
    minLogLevel;
    constructor(minLogLevel) {
        this.minLogLevel = minLogLevel;
        this.#validateLogLevel(minLogLevel);
    }
    trace(message) {
        if (this.#isLogLevelActive('trace')) {
            console.log(`[TRACE]: ${message}`);
        }
    }
    info(message) {
        if (this.#isLogLevelActive('info')) {
            console.log(`[INFO]: ${message}`);
        }
    }
    warn(message) {
        if (this.#isLogLevelActive('warn')) {
            console.warn(`[WARN]: ${message}`);
        }
    }
    error(message, error) {
        if (this.#isLogLevelActive('error')) {
            console.error(message, error);
        }
    }
    #isLogLevelActive(logLevel) {
        return LOG_LEVELS.indexOf(logLevel) >= LOG_LEVELS.indexOf(this.minLogLevel);
    }
    #validateLogLevel(logLevel) {
        if (!LOG_LEVELS.includes(logLevel)) {
            throw new Error(`Unsupported log level: ${logLevel}`);
        }
    }
}
//# sourceMappingURL=logger.js.map